// Material Kit 2 React pages
import Animations from "pages/LandingPages/Animations";

export default function BooksPage() {
  return <Animations />;
}
